<agr-dialog (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div>
    <mat-tab-group
      data-test="feed-profit-settings__tabs"
      animationDuration="0"
      color="accent"
      class="settings-tabs"
      [mat-stretch-tabs]="false"
      (selectedTabChange)="selectedTabChange($event)"
    >
      <mat-tab [label]="'feed-profit.detail.extended-simulation.products-tab' | translate">
        <app-products
          (productsChanged)="calculationSettingsChanged($event)"
          [calculation]="calculation"
        ></app-products>
      </mat-tab>
      <mat-tab
        [label]="'feed-profit.detail.extended-simulation.price-and-feedconversion-tab' | translate"
      >
        <app-baseline-settings
          [isExtendedSimulation]="true"
          [calculation]="calculation"
        ></app-baseline-settings>
      </mat-tab>
      <mat-tab [label]="'feed-profit.detail.extended-simulation.extended-baseline-tab' | translate">
        <app-extended-baseline-settings
          [isExtendedSimulation]="true"
          [calculation]="calculation"
        ></app-extended-baseline-settings>
      </mat-tab>
    </mat-tab-group>
  </div>
</agr-dialog>
